<div mode="card" >
 
    <div class="ItemSearch">
      <h3>{{filterValue}}</h3>
      
    </div>
    <div class="table-responsive" style="text-align: center;" *ngIf="itemList?.length === 0">
      No data found
    </div>
    <div class="table-responsive" *ngIf="itemList?.length > 0">
      <table class="table table-hover" width="100%">
        <thead>
          <tr>
            <th width="30px"><input style="cursor: pointer;" type="checkbox" (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"></th>
            <th>Question</th>
            <th>Question Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itemList">
            <td width="30px">
              <input type="checkbox" style="cursor: pointer;" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(item) : null"
                [checked]="selection.isSelected(item)">
            </td>
            <td title="Question">{{item?.title}}</td>
            <td title="Question Type">{{item?.type | titlecase}}</td>
          </tr>
          <tr>
            <td colspan="4" *ngIf="show < total"></td>
          </tr>
        </tbody>
        
      </table>
     
    </div>
    <div class="flexwrap" style="margin-top: 10px;">

      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" *ngIf="itemList?.length > 0" style="width:100%;">
          
        <button mat-button class="sub-button" [disabled]="selection.selected.length < 0"
        (click)="assignItems()">Assign</button>
        <button mat-button class="can-button" (click)="cancel()"><span>Cancel</span></button>
      </div>
    </div>
   